export default __webpack_public_path__ + "static/media/doc.77ed92c1.svg";